import { Routes } from '@angular/router';
import {PortfolioComponent} from "./ui/modules/home/portfolio/portfolio.component";
import {WorkDetailsComponent} from "./ui/modules/home/work-details/work-details.component";
import {TeamComponent} from "./ui/modules/home/team/team.component";
import {TechStackComponent} from "./ui/modules/home/tech-stack/tech-stack.component";
import {HomeComponent} from "./ui/modules/home/home.component";

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () => import('./ui/modules/home/home.routes'),
    data: { layoutMode: 'transparent' },
  },
  {
    path: 'case-studies',
    component: PortfolioComponent
  },
  {
    path: 'case-studies/:id',
    component: WorkDetailsComponent
  },
  {
    path: 'team',
    component: TeamComponent
  },
  {
    path: 'tech-stack',
    component: TechStackComponent
  },
  {
    path: '**',
    component: HomeComponent
  }
];
